import styled, { css } from 'styled-components'
import AesImage from 'component/AesImage'
import { AppNavLink } from 'app-layered-layout/AppNavLink'
import { NavIconMap } from './iconMap'

interface NavIconProps {
  imageName: string
  active?: boolean
}

interface NavTextProps {
  active?: boolean
}

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-height: var(--item-height);
  box-sizing: content-box;
  font-size: 0.32rem;
  z-index: 1;
  background: var(--page-footer-background);
  color: var(--page-footer-color);
  box-shadow: var(--page-footer-box-shadow);
  border-top: var(--page-footer-border-top);
  --item-height: 1.41rem;
`

export const TagA = styled(AppNavLink)`
  z-index: 2;
  width: 20%;
  flex: 1 1 auto;
`

const commonIconStyle = css`
  width: 0.5384rem;
  height: 0.5384rem;
`

const getNavIcon = (baseName: string, isActive: boolean) => {
  const key = isActive ? `${baseName}_active` : baseName
  return NavIconMap[key] || ''
}

export const NavIcon = styled.i<NavIconProps>`
  ${commonIconStyle}

  background: url(${({ imageName }) => getNavIcon(imageName, false)}) no-repeat center center;
  background-size: contain;

  ${({ active, imageName }) =>
    active
      ? css`
          background: url(${getNavIcon(imageName, true)}) no-repeat center center;
          background-size: contain;
        `
      : ''}
`

export const NavAesIcon = styled(AesImage).attrs({ aspectRatio: 1, hasPlaceholder: false, cached: true })`
  ${commonIconStyle}
`

export const Nav = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 0.106rem;
  width: 100%;
  padding-top: 0.2307rem;
  padding-bottom: env(safe-area-inset-bottom, 0.2307rem);
  // height: 100%;
  box-sizing: content-box;
  min-height: calc(var(--item-height) - 0.2307rem);
  cursor: pointer;
`

export const NavigationSpacer = styled.div`
  --item-height: 1.41rem;
  min-height: var(--item-height);
  padding-bottom: env(safe-area-inset-bottom, 0.2307rem);
  box-sizing: content-box;
`

export const NavText = styled.div<NavTextProps>`
  align-self: stretch;
  text-align: center;
  ${({ active }) => (active ? 'background: var(--component-navigation--active-color);' : 'background: currentColor;')}
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  text-fill-color: transparent !important;
`
